module.exports = __webpack_public_path__ + "img/shared.04f5ff2c.png";